import React from "react";
import styles from "./trackingArtwork.module.scss";

const BACKGROUND =
  "https://d1flzashw70bti.cloudfront.net/next-gen/images/selfHelp/lightOtherImage_1789022302284.webp";
const BACKGROUND_MAXX =
  "https://d1flzashw70bti.cloudfront.net/next-gen/images/selfHelp/darkMaxxImage_1789022302283.webp";

// Full-bleed artwork used whenever there is no live map to show. The bus
// illustration and gradient come from the image; the copy is rendered on top
// so it stays legible and editable per state.
const TrackingArtwork = props => {
  const { isMaxService, title, subtitle } = props;

  return (
    <div className={isMaxService ? styles.artworkMaxx : styles.artwork}>
      <img
        className={styles.background}
        src={isMaxService ? BACKGROUND_MAXX : BACKGROUND}
        alt=""
      />
      <div className={styles.content}>
        <span className={styles.title}>{title}</span>
        <span className={styles.subtitle}>{subtitle}</span>
      </div>
    </div>
  );
};

export default TrackingArtwork;
